import 'bootstrap';

import Swiper from 'swiper';
import { Mousewheel, Keyboard, Autoplay } from 'swiper/modules';
import 'swiper/css';

window.Swiper = Swiper;
window.SwiperModules = { Mousewheel, Keyboard, Autoplay };
